import BaseObject from '../../../base/base_object';
import {SYSTEM_EVENTS} from '../../../events/events';
import Event from '../../../utils/event';
import DateFormatter from '../../../utils/date_formatter';
import ServiceFactory from '../../service_factory';
import IRestrictionMessages from './restriction_messages_interface';

const DEFAULT_DATETIME_FORMATTING = 'dd.mm.yyyy H:MM';

export default class RestrictionMessages extends BaseObject implements IRestrictionMessages{
    static CLASS = 'GenericRestrictionMessage';
    private _serviceFactory: ServiceFactory;

    init(params) {
        super.init(params);
        this._serviceFactory = params.serviceFactory;
    }

    public showGenericMessage(): void {
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
            text: this._serviceFactory.languageService().translation('100200'),
            type: 'error',
            analytic: {category: 'Client_RestrictionError'}
        });
    }

    public showSessionLimitMessage(expirationDate: any): void {
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
            title: this._serviceFactory.languageService().translation('slots_self_restriction_title'),
            text: this._serviceFactory.languageService().translation('slots_self_restriction_message', {
                restrictionExpirationDate: this._formatDate(expirationDate)
            }),
            type: 'error',
            analytic: {category: 'Client_SelfRestrictionError'}
        });
    }

    private _formatDate(date: any) {
        return  DateFormatter.format(date, this._serviceFactory.skinService().getDateTimeFormat() || DEFAULT_DATETIME_FORMATTING);
    }
}